import toast from "react-hot-toast";
import {BaseResponse, BaseResponseFields, BaseResponseWithData} from "../types";
import {useLoader} from "./useLoader";

export type FetchDataFunction = <T>(
    promise: () => Promise<BaseResponseWithData<T> | BaseResponse>,
    blockUI?: boolean
  ) => Promise<T | true | undefined>;  
  

type FetchAllDataFunction = (
    promises: Iterable<Promise<BaseResponseWithData<any>>>,
    blockUI?: boolean
) => Promise<(any | undefined)[]>;

const useAxios = <T extends BaseResponse = BaseResponseWithData<any> | BaseResponse> () => {
    const {showLoader, hideLoader} = useLoader();

    const fetchData = async (
        promise: () => Promise<T>,
        blockUI = false
    ) => {
        if (blockUI) showLoader();

        return promise()
            .then((response: T) => {
                if (!response[BaseResponseFields.HasError])

                    // @ts-ignore
                    return (response[BaseResponseFields.Data] || response || true) as T;

                toast.error(response[BaseResponseFields.ErrorDescription]);

                return Promise.reject(undefined);
            })
            .catch((err: BaseResponseWithData<any>) => {
                toast.error(err[BaseResponseFields.ErrorDescription]);

                return Promise.reject(undefined);
            })
            .finally(() => {
                if (blockUI) hideLoader();
            });
    };

    const fetchAllData = async (
        promises: Iterable<Promise<BaseResponseWithData<any>>>,
        blockUI = false
    ) : Promise<any[] | undefined> => {
        if (blockUI) showLoader();

        return Promise.all(promises)
            .then(responses => {
                const responseData : any[] = []
                
                responses.forEach(response => {
                    if (response[BaseResponseFields.HasError]) {
                        toast.error(response[BaseResponseFields.ErrorDescription]);
                        responseData.push(undefined);
                    } else 
                        responseData.push(response[BaseResponseFields.Data] || true)
                })
                
                return responseData;
            })
            .catch((err: BaseResponseWithData<any>) => {
                toast.error(err[BaseResponseFields.ErrorDescription]);

                return Promise.reject(undefined);
            })
            .finally(() => {
                if (blockUI) hideLoader();
            });
    };
    
    return { fetchData, fetchAllData };
};

export default useAxios;